<template>
    <div class="flex items-center text-muted">
        <hr class="mr-2 grow border-t border-muted" />
        <span class="px-2 text-center">
            <slot></slot>
        </span>
        <hr class="ml-2 grow border-t border-muted" />
    </div>
</template>
